import axios from 'axios'
import {
  MATCHING_PAYOUT_DETAILED_URL,
  MATCHING_PAYOUT_FULL_URL,
  MATCHING_PAYOUT_SUMMARY_URL,
} from './consts'
import {
  IMatchingPayoutReportRow,
  IMatchingPayoutSummaryRow,
} from '../ReportsPage.types'
import { ReportOutcome } from '../core/types'

/**
 * Тело запроса отчёта по выплатам мэтчинга (CPAYMENT-1760).
 *
 * Кассы здесь нет намеренно: у выплат мэтчинга `cashbox_id` не заполняется, поэтому бэкенд
 * фильтр по кассе игнорирует, а колонки кассы в отчёте не существует.
 */
export interface IMatchingPayoutReportParams {
  dateStart: string
  dateEnd: string
  merchantTokenList: string[]
  paymentAdapterIdList: number[]
  paymentMethods: string[]
  /** Укрупнённый исход ВЫПЛАТЫ; пустой список — все финальные выплаты периода. */
  outcomes: ReportOutcome[]
  byCompletionDate?: boolean
  page?: number
  perPage?: number
}

export interface IMatchingPayoutSummaryResponse {
  data: IMatchingPayoutSummaryRow[]
  success: boolean
  totalRows: number
  errors: any
}

export interface IMatchingPayoutDetailedResponse {
  data: IMatchingPayoutReportRow[]
  success: boolean
  totalRows: number
  errors: any
}

export const getMatchingPayoutSummary = (params: IMatchingPayoutReportParams) =>
  axios.post<IMatchingPayoutSummaryResponse>(MATCHING_PAYOUT_SUMMARY_URL, params)

export const getMatchingPayoutDetailed = (params: IMatchingPayoutReportParams) =>
  axios.post<IMatchingPayoutDetailedResponse>(MATCHING_PAYOUT_DETAILED_URL, params)

export const exportMatchingPayoutReport = (params: IMatchingPayoutReportParams) =>
  axios.post<Blob>(MATCHING_PAYOUT_FULL_URL, params, { responseType: 'blob' })
